import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  footer,
  padding = 'p-6',
  className = '',
  hover = false,
  onClick
}) => {
  const cardStyles = `
    bg-white rounded-lg shadow-md border border-gray-200 
    ${hover ? 'hover:shadow-lg transition-shadow duration-200 cursor-pointer' : ''}
    ${className}
  `;

  return (
    <div className={cardStyles} onClick={onClick}>
      {(title || subtitle) && (
        <div className={`border-b border-gray-200 ${padding}`}>
          {title && (
            <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          )}
          {subtitle && (
            <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
          )}
        </div>
      )}
      
      <div className={padding}>
        {children}
      </div>

      {footer && (
        <div className={`border-t border-gray-200 ${padding} bg-gray-50 rounded-b-lg`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;